/**
 * Section « Menu / Choisissez votre envie » — portée À L'IDENTIQUE du legacy.
 * Grille de catégories en cartes à dégradé de marque + emoji géant en filigrane,
 * voile sombre, nom et nombre de produits. Clic → défile vers la catégorie du menu.
 * Données 100 % tenant (catégories de la base, couleurs via variables CSS).
 */
export interface CategoryCard {
  id: string;
  name: string;
  emoji?: string | null;
  count: number;
}

interface CategoryGridProps {
  categories: CategoryCard[];
  productCount: number;
  onPick: (categoryId: string) => void;
}

export default function CategoryGrid({ categories, productCount, onPick }: CategoryGridProps) {
  if (categories.length === 0) return null;

  return (
    <section className="bg-gray-50 py-16 lg:py-24">
      <div className="mx-auto max-w-7xl px-4 lg:px-6">
        <div className="mx-auto mb-12 max-w-2xl text-center">
          <div
            className="mb-2 text-sm font-bold uppercase tracking-widest"
            style={{ color: 'var(--brand-primary)' }}
          >
            Menu
          </div>
          <h2 className="display-font text-4xl font-black lg:text-6xl">Choisissez votre envie</h2>
          <p className="mt-3 text-gray-600">
            {categories.length} catégories, {productCount} produits, tous préparés sur place.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4 lg:gap-5">
          {categories.map((c) => (
            <button
              key={c.id}
              onClick={() => onPick(c.id)}
              className="group relative h-44 overflow-hidden rounded-2xl shadow-md transition-all hover:shadow-2xl lg:h-52"
            >
              <div
                className="absolute inset-0 transition-transform duration-500 group-hover:scale-110"
                style={{
                  background: 'linear-gradient(135deg, var(--brand-primary), var(--brand-dark, #1a1a1a))',
                }}
              />
              {c.emoji && (
                <div className="absolute inset-0 flex items-center justify-center text-7xl opacity-30">
                  {c.emoji}
                </div>
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
              <div className="absolute inset-0 flex flex-col justify-end p-4 text-left text-white lg:p-5">
                {c.emoji && <div className="mb-2 text-3xl">{c.emoji}</div>}
                <div className="text-lg font-extrabold lg:text-xl">{c.name}</div>
                <div className="mt-1 text-xs font-bold uppercase tracking-wide opacity-80">
                  {c.count} produit{c.count > 1 ? 's' : ''} →
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
